import { useCallback, useEffect, useRef, useState } from 'react';

import { getColumns, handleColumnResize } from '../TableHelpersOpz';

import { PROPERTY_TABLE_COLUMNS } from './constants';

export default function usePropertyTableColumnsLayout() {
  const [columns, setColumns] = useState<any>();
  const disconnectReference = useRef<(() => void) | undefined>();

  const setHostReference = useCallback((node: HTMLElement | null) => {
    disconnectReference.current?.();
    disconnectReference.current = undefined;
    if (!node) return;

    const applyWidth = () => {
      setColumns(getColumns(PROPERTY_TABLE_COLUMNS as unknown as any[], node.offsetWidth, 76));
    };

    applyWidth();
    const ro = new ResizeObserver(applyWidth);
    ro.observe(node);
    disconnectReference.current = () => ro.disconnect();
  }, []);

  useEffect(
    () => () => {
      disconnectReference.current?.();
    },
    [],
  );

  const onColumnResized = useCallback(
    (ci: any, width: any) => handleColumnResize(ci, width, setColumns),
    [],
  );

  return { setHostRef: setHostReference, columns, onColumnResized };
}
